import CheckboxPC from "./CheckboxPC.vue.mjs";
const Checkbox = CheckboxPC;
export {
  Checkbox as default
};
